import { configureStore } from '@reduxjs/toolkit'
import discussionsReducer from './discussionsSlice'
import userReducer from './userSlice'

const store = configureStore({
  reducer: {
    discussions: discussionsReducer,
    user: userReducer
  }
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch